export default {
  async existemTransacoesAgendadas(codigoConta) {
    let th = this

    let existemTransacoesAgendadas = false

    let dto = {
      parameters: [
        { name: 'codigoConta', value: codigoConta },
        { name: 'dtInicio', value: new Date() },
        { name: 'situacao', value: th.$api.Enums.SituacaoAgendamento.Agendado }
      ]
    }

    await th.$api.LancamentosFuturos.GetLancamentosFuturos(dto).then(
      response => {
        if (!response.length || response.length === 0) return

        if (th.$api.UI.PostAction(response, '', false))
          existemTransacoesAgendadas = true
      }
    )

    return existemTransacoesAgendadas
  }
}
